
import React, { FC, useEffect } from 'react'

import { ampli } from '@Analytics/ampli'
import { SuccessPromptV3 } from '@Domains/Cart/Components/Prompt/Successv2/SucesssPromptV3'
import {
  AddToCartMutation,
  AddToCartProductInput,
  RecommendationContentFragment,
  useCartQuery,
} from '@Generated/graphql'

type AddToCartMutationType = NonNullable<AddToCartMutation['addToCart']>
type PromptsType = NonNullable<AddToCartMutationType['prompts']>[0]
type SuccessPromptType = Extract<PromptsType, { __typename: 'AddToCartPromptSuccess' }>
export type SuccessPromptTactic = NonNullable<SuccessPromptType['tactic']>

export interface SuccessPromptProps {
  onClose: () => void
  // eslint-disable-next-line react/no-unused-prop-types
  onModalWithin?: (open: boolean) => void
  // eslint-disable-next-line @typescript-eslint/member-ordering
  onModalToggle?: (open: boolean) => void
  origins?: null | AddToCartProductInput[]
  primaryLineItemID?: string
  recommendations: NonNullable<RecommendationContentFragment['recommendations']>
  tactic?: SuccessPromptTactic | null
}

const GIFT_ID = '26342'

export const SuccessPromptV2: FC<SuccessPromptProps> = ({
  onClose,
  onModalToggle,
  origins,
  primaryLineItemID,
  recommendations,
  tactic,
}) => {
  const { data } = useCartQuery({
    context: {
      domainProxy: true,
      userSpecific: true,
    },
  })
  useEffect(() => {
    ampli.promptOpen({ source_id: 'success_prompt' })
  }, [])
  return (
    <SuccessPromptV3
      data={data}
      giftId={GIFT_ID}
      onClose={onClose}
      onModalToggle={onModalToggle}
      origins={origins}
      primaryLineItemID={primaryLineItemID}
      recommendations={recommendations}
      tactic={tactic}
    />
  )
}

